import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ButtonGroup, Button as ReactstrapButton } from 'reactstrap';
import { Button } from '../../../UI/Common';
import { sortBy } from 'lodash';
import { getDragIconStyle, getItemStyle, reorder } from './functions';

const WidgetList = ({
  usingWidgets,
  availableWidgets,
  isActive,
  setIsActive,
  onAddWidget,
  onRemoveWidget,
  onReorderWidget,
}) => {
  function onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const widgets = reorder(
      usingWidgets,
      result.source.index,
      result.destination.index,
    );
    onReorderWidget(widgets);
  }
  const UsingWidgetButton = ({ snapshot, children, ...props }) => {
    const { id } = props;
    return (
      <ButtonGroup className="w-100">
        <Button
          color="transparent"
          classes="h-100"
          style={{ padding: 0, width: 20 }}
          onClick={() => onRemoveWidget(props)}
        >
          <i className="md-icon mr-0">delete_outline</i>
        </Button>
        <Button
          id={id}
          color="transparent"
          onClick={() => {
            if (isActive === id) {
              setIsActive('');
            } else {
              setIsActive(id);
            }
          }}
          classes={isActive === id ? 'bg-goldenrod color-white' : ''}
          style={{ width: '100%', height: 'fit-content' }}
        >
          {children}
        </Button>
        <ReactstrapButton
          tag="div"
          className="h-100 d-flex align-items-center"
          style={{
            minWidth: 20,
            padding: 0,
            cursor: 'grab',
            borderRadius: 0,
            ...getDragIconStyle(snapshot.isDragging),
          }}
        >
          <i className="md-icon mr-0" style={{ verticalAlign: 'middle' }}>
            drag_handle
          </i>
        </ReactstrapButton>
      </ButtonGroup>
    );
  };
  const AvailableWidgetButton = ({ children, ...props }) => (
    <Button
      color="primary"
      classes="mb-1"
      style={{ width: '100%', height: 'fit-content', borderWidth: 0 }}
      onClick={() => onAddWidget(props)}
    >
      {children}
    </Button>
  );
  return (
    <div className="widget-list-section">
      <div className="available-widgets mb-1">
        <div className="available-widgets-container">
          {availableWidgets.length
            ? sortBy(availableWidgets, ['widgetTypeName']).map(
                (availableWidget) => (
                  <AvailableWidgetButton
                    key={availableWidget.widgetTypeId}
                    {...availableWidget}
                  >
                    {availableWidget.widgetTypeName}
                  </AvailableWidgetButton>
                ),
              )
            : null}
        </div>
      </div>
      <div className="in-use-widgets">
        <div className="text-center" style={{ borderTopStyle: 'double' }}>
          Components
        </div>
        <div className="in-use-widgets-container">
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="usingWidgetsList">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  // className="d-flex flex-column"
                  // style={getListStyle(snapshot.isDraggingOver, props.color)}
                >
                  {usingWidgets.length
                    ? usingWidgets.map((usingWidget, index) => (
                        <Draggable
                          key={usingWidget.id}
                          draggableId={usingWidget.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style,
                                index === usingWidgets.length - 1,
                              )}
                            >
                              <UsingWidgetButton
                                snapshot={snapshot}
                                key={usingWidget.id}
                                {...usingWidget}
                              >
                                {usingWidget.widgetTypeName}
                              </UsingWidgetButton>
                            </div>
                          )}
                        </Draggable>
                      ))
                    : null}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    </div>
  );
};

export default WidgetList;
